import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ab710710"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "dev-wrapper" }

import { provide } from "vue";
import ExamForm from "@/modules/exam-listing-lab/ExamForm.vue";
import type { EnhancedLabPermissions } from "@/modules/exam-listing-lab/types/lab";
import { FeegowLabApi } from "@/utils/feegow-lab";


export default /*#__PURE__*/_defineComponent({
  __name: 'ExamFormDevView',
  setup(__props) {

const permissions: EnhancedLabPermissions = {
  cadastroexamesV: 1,
  cadastroexamesI: 1,
  cadastroexamesA: 1,
  cadastroexamesX: 1,
  isAllowed: () => true,
};

provide("labPermissions", permissions);

// Insere um token dummy para evitar erros de token em chamadas acidentais
try {
  window.localStorage.setItem("tk", "dev-token");
} catch {}

// Mock simples dos endpoints usados pelo ExamForm
const mockSamples = [
  { id: 101, CodAmostra: "B01", descamostra: "Sangue Total" },
  { id: 102, CodAmostra: "U01", descamostra: "Urina" },
];

const mockProcedures = [
  { id: 201, NomeProcedimento: "Hemograma Completo" },
  { id: 202, NomeProcedimento: "Glicemia Jejum" },
];

(FeegowLabApi as any).getSamplesByLab = async () => mockSamples;
(FeegowLabApi as any).getProcedures = async () => mockProcedures;
(FeegowLabApi as any).insertExamLicense = async () => ({ success: true });
(FeegowLabApi as any).updateExamLicense = async () => ({ success: true });
(FeegowLabApi as any).fetchExamDetails = async () => ({ success: true });

const mockExam = {
  id: 123,
  labID: 5,
  amostraID: 101,
  codExame: "HB001",
  nomeExame: "Hemograma",
  correspondingProcedureId: 201,
  correspondingProcedureName: "Hemograma Completo",
  tipoMaterial: "Sangue",
  metodologia: "Automatizada",
  camposAdicionais: "Jejum: 8h",
  conservante: "EDTA",
  diasParaResultado: 2,
  diasAdicionais: "",
  camposObrigatorios: { volume: true, altura: false, peso: false, regiao: false },
  ObsExame: true,
  IdadeGestacional: false,
  ultimaMenstruacaoData: false,
  FertilizacaoInVitro: false,
  IdadeMae: false,
  CadeiaCustodia: false,
};

function onSave() {}
function onCancel() {}
function onChange() {}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(ExamForm, {
      exam: mockExam,
      loading: false,
      onSave: onSave,
      onCancel: onCancel,
      onChange: onChange
    })
  ]))
}
}

})